export function chunk<T>(array: T[], length: number) {
  return Array.from({ length: Math.ceil(array.length / length) }).map((_, i) =>
    array.slice(i * length, i * length + length)
  );
}
